import constructSlug from '@/utils/construct-slug';
import type { VehicleSearchResult } from '@tac/vehicle-api-client/types';

type GetVehicleDetailsHrefParams = {
  makeSlug: string;
  modelSlug: string;
  year?: string | number;
  vehicleSlug?: string;
};

export const getVehicleDetailsHref = ({
  makeSlug,
  modelSlug,
  year,
  vehicleSlug,
}: GetVehicleDetailsHrefParams): string => {
  let path = `/${makeSlug}/${modelSlug}`;
  if (year) path += `/${year}`;
  if (vehicleSlug) path += `?vehicle=${encodeURIComponent(vehicleSlug)}`;
  return path;
};

export const getVehicleDetailsHrefFromNames = ({
  make,
  model,
  year,
  variant,
}: {
  make: string;
  model: string;
  year?: string;
  variant?: string;
}): string => {
  return getVehicleDetailsHref({
    makeSlug: constructSlug(make),
    modelSlug: constructSlug(model),
    year,
    vehicleSlug: variant,
  });
};

export const getVehicleDetailsHrefFromVehicle = (vehicle: VehicleSearchResult): string => {
  return getVehicleDetailsHref({
    makeSlug: vehicle.makeslug ?? constructSlug(vehicle.makedescription),
    modelSlug: vehicle.modelslug ?? constructSlug(vehicle.modeldescription),
    year: vehicle.year,
    vehicleSlug: constructSlug(vehicle.description),
  });
};
